<template>
  <div>
    <Head title="Dashboard profissional" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Dashboard profissional</h1>
      <data-table
        v-if="loadTable"
        search-label="Pesquisar por nome, e-mail ou CPF"
        v-model:columns="columns"
        route="professionals-dashboard/list"
        no-data-label="Nenhum profissional de saúde cadastrado"
        no-result-label="Nenhum profissional de saúde encontrado"
      >
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-1">
            <Link :href="'professionals-dashboard/' + row.id" class="btn-primary font-normal text-xs px-6 py-2.5">Ver dashboard</Link>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-1">
            
          </div>
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import DataTable from '@/Shared/Components/DataTable'

export default {
  props: {
    states_options: Object,
    class_entity_options: Object,
  },
  components: {
    Head,
    Link,
    DataTable,
  },
  layout: Layout,
  mounted() {
    
  },
  setup() {

  },
  data() {
    return {
      specialties: [],
      groups: [],
      loadTable: true,
      columns: [
        {
          uniqid: 'professional_name',
          label: 'Nome',
          field: 'users.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.name}`,
        },
        {
          uniqid: 'professional_specialty',
          label: 'Especialidade',
          field: 'specialties.name',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.specialties_labels ? row.specialties_labels : ''
        },
        {
          uniqid: 'professional_email',
          label: 'E-mail',
          field: 'users.email',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.email}`,
        },
        {
          uniqid: 'professional_cpf',
          label: 'CPF',
          field: 'cpf',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'professional_class_number',
          label: 'Registro de classe',
          field: 'class_number',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.class_number ? row.class_entity_label + ': ' + row.class_number  + '-' + row.uf : ''
        },
        {
          uniqid: 'actions',
          label: 'Dashboard',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
  },
}
</script>